import { TRANSLATION_KEYS } from "./TranslationKeys";

import type { ToastProps } from "components/toasts/MessageToast";

export const WORKFLOWS_TOASTS_IDS = {
  approveConflictError: "approve-conflict-error-toast-id",
  cancelConflictError: "cancel-conflict-error-toast-id",
  customerNamesFailure: "customer-names-error-toast-id",
  dontHavePermission: "dont-have-permission-error-toast-id",
  editConflictError: "edit-conflict-error-toast-id",
  usernamesFailure: "usernames-error-toast-id",
  workflowApproveSuccess: "workflow-approve-success-toast-id",
  workflowCancelSuccess: "workflow-cancel-success-toast-id",
  workflowDeclineSuccess: "workflow-approve-success-toast-id",
  workflowEditSuccess: "workflow-edit-success-toast-id",
  workflowsListFailure: "workflows-list-error-toast-id",
} as const;

export const WORKFLOWS_TOASTS = {
  customerNamesFailure: {
    bodyContent: TRANSLATION_KEYS.cannotLoadCustomerNames,
    variant: "failure",
    config: {
      toastId: WORKFLOWS_TOASTS_IDS.customerNamesFailure,
    },
  },
  listFailure: {
    bodyContent: TRANSLATION_KEYS.cannotLoadWorkflowsList,
    variant: "failure",
    config: {
      toastId: WORKFLOWS_TOASTS_IDS.workflowsListFailure,
    },
  },
  usernamesFailure: {
    bodyContent: TRANSLATION_KEYS.cannotLoadUsernames,
    variant: "failure",
    config: {
      toastId: WORKFLOWS_TOASTS_IDS.usernamesFailure,
    },
  },
} as const;

export const APPROVE_WORKFLOWS_TOASTS = {
  approveSuccess: (message: string): ToastProps => ({
    bodyContent: message,
    variant: "success",
    config: {
      toastId: WORKFLOWS_TOASTS_IDS.workflowApproveSuccess,
    },
  }),
  conflictError: (message: string): ToastProps => ({
    bodyContent: message,
    variant: "failure",
    config: {
      toastId: WORKFLOWS_TOASTS_IDS.approveConflictError,
    },
  }),
} as const;

export const EDIT_WORKFLOWS_TOASTS = {
  editSuccess: (message: string): ToastProps => ({
    bodyContent: message,
    variant: "success",
    config: {
      toastId: WORKFLOWS_TOASTS_IDS.workflowApproveSuccess,
    },
  }),
  conflictError: (message: string): ToastProps => ({
    bodyContent: message,
    variant: "failure",
    config: {
      toastId: WORKFLOWS_TOASTS_IDS.editConflictError,
    },
  }),
} as const;

export const CANCEL_WORKFLOWS_TOASTS = {
  cancelSuccess: (message: string): ToastProps => ({
    bodyContent: message,
    variant: "success",
    config: {
      toastId: WORKFLOWS_TOASTS_IDS.workflowCancelSuccess,
    },
  }),
  conflictError: (message: string): ToastProps => ({
    bodyContent: message,
    variant: "failure",
    config: {
      toastId: WORKFLOWS_TOASTS_IDS.cancelConflictError,
    },
  }),
} as const;

export const DECLINE_WORKFLOWS_TOASTS = {
  declineSuccess: (message: string): ToastProps => ({
    bodyContent: message,
    variant: "success",
    config: {
      toastId: WORKFLOWS_TOASTS_IDS.workflowApproveSuccess,
    },
  }),
  conflictError: (message: string): ToastProps => ({
    bodyContent: message,
    variant: "failure",
    config: {
      toastId: WORKFLOWS_TOASTS_IDS.approveConflictError,
    },
  }),
} as const;
